import { Check, X } from "lucide-react";
import styled from "styled-components";
import { getPasswordRequirements } from "@/shared/utils/passwordValidation";

const Requirements = styled.ul`
	list-style: none;
	padding: 0;
	margin: 4px 0 0;
	display: grid;
	gap: 4px;
`;

const Requirement = styled.li<{ $valid: boolean }>`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 12px;
	line-height: 18px;
	color: ${(props) => (props.$valid ? "#2b8a3e" : "#707070")};
`;

const VisuallyHidden = styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	overflow: hidden;
	clip: rect(0 0 0 0);
	white-space: nowrap;
`;

interface PasswordRequirementsProps {
	id?: string;
	password: string;
}

/** Live checklist of the sign-up password rules. */
export const PasswordRequirements = ({ id, password }: PasswordRequirementsProps) => (
	<Requirements id={id} aria-label="Password requirements">
		{getPasswordRequirements(password).map((item) => (
			<Requirement key={item.label} $valid={item.valid}>
				{item.valid ? <Check size={16} aria-hidden /> : <X size={16} aria-hidden />}
				<span>
					{item.label}
					<VisuallyHidden>{item.valid ? " (met)" : " (not met)"}</VisuallyHidden>
				</span>
			</Requirement>
		))}
	</Requirements>
);
